import React from 'react';
import { Nav } from './components/Nav';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { AWeekWithUs } from './components/AWeekWithUs';
import { QuoteBand } from './components/QuoteBand';
import { WhatsIncluded } from './components/WhatsIncluded';
import { Locations } from './components/Locations';
import { Waitlist } from './components/Waitlist';
import { Footer } from './components/Footer';
import { StickyCTA } from './components/StickyCTA';
export function App() {
  return <div className="w-full min-h-screen bg-paper text-ink" data-id="element-0">
      <Nav data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <About data-id="element-4" />
        <AWeekWithUs data-id="element-5" />
        <QuoteBand data-id="element-6" />
        <WhatsIncluded data-id="element-7" />
        <Locations data-id="element-8" />
        <Waitlist data-id="element-9" />
      </main>
      <Footer data-id="element-10" />
      <StickyCTA data-id="element-11" />
    </div>;
}